module.exports = __webpack_public_path__ + "img/sidebar-standards-ico-wht-01.8318f811.svg";